// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"213":"38f21314","453":"4e5d1451","455":"5911c391"}[chunkId] + ".chunk.js";
};